$(document).on('click', '.dnPaymentSelect-button', function (event) {
    event.stopPropagation();
});
